module.exports = __webpack_public_path__ + "img/awlnsw.d998a1a.png";